//
// CollectionsManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "./Voucher";
import "../models/local/Folder";

var CollectionsManager = createModule("transport::CollectionsManager", ["transport::SubserviceManager"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        _subscribeToCollection_s: [1,7],
        getCollections: [1],
        getFolderContent: [1,1],
        _subscribeToCollection_o: [1,1],
        checkForUpdates: [1,1],
        getRootCollectionsFolder: [1],
        isValidFolder: [2,1],
    },
    ,
    ["subscribeToCollection"],
]);
export default CollectionsManager;
